import en from './en.json';
import fr from './fr.json';

export const calendarI18n = {
  fr,
  en,
};
